/**
 * Returns the value passed as an argument.
 *
 * ```ts
 * tt.identity('a');
 * // => 'a'
 * ```
 *
 * @param v The value to return.
 * @returns v
 */
export function identity(v: any) {
  return v;
}
